module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/header-date@3x-f544bcb03255031a67b2430d28dc4517.png";